/**
 * The approved Refresh copy (PD-35 delta 3, PD-36 N1): the control says which entity it re-reads,
 * and a helper line says nothing updates by itself (PD-33 made visible). One place for the strings,
 * so the TPIN view, the branch view and the three worklist views cannot drift apart.
 */

export const REFRESHING_LABEL = 'Refreshing…'

export const REFRESH_TPIN_LABEL = 'Refresh this TPIN'
export const REFRESH_TPIN_NOTE = 'Updates only when you press Refresh. Refreshes this TPIN only.'

export const REFRESH_LABEL = 'Refresh this branch'
export const REFRESH_NOTE = 'Updates only when you press Refresh. Refreshes this branch only.'
